import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import { openDashboardDialog } from '@actions/dashboard-actions';
import * as dialog from '@constants/dialogs';
import OverlapStatusRow from '@shared/overlap-status-row';
import './conflict-list-item.scss';

const ConflictListItem = ({ entity, mainEntity, onClick }) => {
  const dispatch = useDispatch();
  const groupId = useSelector(state => state.groups.edit.group.id);

  const handleClick = useCallback(() => {
    const { id, segments, type_name } = entity;
    onClick(type_name, id, segments);
  }, [entity, onClick]);

  const onViewStatusClick = useCallback(event => {
    event.stopPropagation();
    if (entity && mainEntity) {
      const {
        agency_name,
        category_dict,
        id,
        icon,
        name,
        start_date,
        end_date,
        overlap_status,
        type_name
      } = entity;
      const params = {
        entityId: mainEntity.id,
        groupId,
        entity: {
          agency_name,
          category_dict,
          id,
          icon,
          name,
          start_date,
          end_date,
          overlap_status,
          type_name
        },
        mainEntity,
        overlapEntityId: id,
        overlapId: R.pathOr(null, [0, 'overlap'], overlap_status)
      };
      dispatch(openDashboardDialog(dialog.OVERLAP_STATUS, params));
    }
  }, [dispatch, entity, groupId, mainEntity]);

  const { id, name } = entity;

  return (
    <div styleName="conflict-list-item-container" onClick={handleClick} role="presentation">
      <div styleName="title">
        {name} &bull;&nbsp;<div styleName="id">ID&nbsp;{id}</div>
      </div>
      <div styleName="footer">
        <OverlapStatusRow
          isOpportunity={false}
          itemEntityType={entity.type_name}
          mainAgency={mainEntity.agency}
          mainEntityType={mainEntity.type_name}
          mainOverlapStatus={mainEntity.overlap_status}
          onClick={onViewStatusClick}
          overlapStatus={entity.overlap_status}
        />
      </div>
    </div>
  );
};

ConflictListItem.propTypes = {
  entity: PropTypes.object,
  mainEntity: PropTypes.object,
  onClick: PropTypes.func
};

export default ConflictListItem;
